<script>
    import { getLiveReceiver, getReceivingLines } from "../../domain/session/receivers.actions";
    import generateKeyPair, { decryptData } from 'services/encryption_keys';
    import { connect, initiateCall } from "domain/call/telephony.actions";
    import ButtonRounded from "../../common/ButtonRounded.svelte"
    import AuthHeader from '../../components/AuthHeader.svelte';
    import AuthFooter from '../../components/AuthFooter.svelte';
    import sessionStore from 'store/session';
    import callStore from 'store/call';
    import authState from 'store/auth';
    import { onMount } from "svelte";
    import pubsub from 'sweet-pubsub';
    import { formatNumber, isValidPhone, ICONS, defaultCountry, countries } from "../../services/utils";
    import toast from '../../services/toast';
    import { useQuery } from "@sveltestack/svelte-query";
    import { getQueueContacts as GetQueueContacts, removeFromQueue as RemoveFromQueue } from "../../domain/call/queue.action";
    import { getBusinesses as GetBusinesses } from '../../domain/session/profile.action'
    import authStore from '../../store/auth';
    import Icon from '../../components/Icon.svelte';
    import { fly } from 'svelte/transition';
    import { backOut } from 'svelte/easing';




    let phone = ''
    let phoneCode = ''
    let error = ''
    let dropdown = ''
    let country = defaultCountry;

    const handleSelectCountry = _country => {
        country = _country
        dropdown = null
    }

    const initCall = async () => {
        error = ""
        if (!phone || !isValidPhone(phone)) {
            error = "Kindly enter a phone number to call"
            toast.warn(error)
            return
        }
        try {
            initiateCall(formatNumber(phone), {})
        } catch (e) {
            console.dir(e)
        }
    }

    pubsub.on('initiate_call', async (__phone__) => {
        phone = __phone__
        await initCall()
    })

    const updateCallQueue = async () => {
        const { id, pending } = $sessionStore.queue || {}
        if ( !id ) {
            return id;
        }

        const pending_ids = pending.map( contact => contact.contact_id)
        const { data = [] } = await GetQueueContacts($sessionStore.profile.business.id, id)

        const __pending__ = data.filter(contact => !pending_ids.includes(contact.contact_id))

        sessionStore.setQueue({
            id,
            pending: [
                ...pending,
                ...__pending__
            ],
        })
    }

    const UPDATE_QUEUE_CONTACT = useQuery('update_queue_contact', updateCallQueue, {
        refetchInterval: 1000 * 60 * 2.5,
        enabled: !!$sessionStore.queue?.id,
    });

    $UPDATE_QUEUE_CONTACT;

    const trimQueue = async () => {
        const { completed = [], id } = $sessionStore.queue || {};
        const contact_ids = completed.map( contact => contact.contact_id)

        try {
            await RemoveFromQueue($sessionStore.profile.business.id, id, contact_ids)
            sessionStore.setQueue({
                completed: []
            })
        } catch (_) {
            sessionStore.setQueue({
                completed
            })
        }
    }

    const REMOVE_COMPLETED_CALL_FROM_QUEUE = useQuery('remove_completed_call_from_queue', trimQueue, {
        refetchInterval: 1000 * 60 * 6,
        enabled: $sessionStore.queue?.completed?.length > 0,
    });

    $REMOVE_COMPLETED_CALL_FROM_QUEUE;

    let indicateConnection = false;
    $: {
        if ($callStore.sipConnected) {
            indicateConnection = true
            setTimeout(() => {
                indicateConnection = false
            }, 3000);
        }
    }

    onMount( async () => {
        const { pubKey } = $authState;
        const { receiver } = $sessionStore;
        try {
            const { publicKey, privateKey } = await generateKeyPair()
            const response = pubKey ? await getLiveReceiver(publicKey) : await getReceivingLines(publicKey, receiver.id);
            const password = await decryptData(privateKey, response.password);
            const credients = { ...response, password }
            callStore.setCredentials(credients)
        } catch (error) {
            const { message = "Cannot fetch call credentials." } = error
            toast.error({message})
        }
        await loadProfiles()
        await connect();
    })

    const loadProfiles = async () => {
        try {
            const { user, profiles } = await GetBusinesses()
            authStore.setUser(user);
            sessionStore.setProfiles(profiles)

            const profile = profiles.find( p => p.business?.id === $sessionStore.profile.business.id) || {} 
            sessionStore.setProfile(profile);

        } catch (error) {
            const { message = "Ops! seems error occured!"} = error
            toast.error({message})
        } finally {}
    }
    
</script>

{#if dropdown}
<div class="absolute w-full z-20 top-0 bottom-0 bg-gray-700/50" transition:fly>
  {#if dropdown === 1}
    <div class="p-4 rounded-lg m-4 mt-16 shadow-xl bg-white" in:fly={{
      y: -100,
      delay: 100,
      easing: backOut
    }} style="overflow: hidden;">
      <div class="flex justify-between w-full items-center">
        <span class="text-black">Select country code</span>
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <span class="p-1 border border-gray-300 rounded-md cursor-pointer" on:click={() => dropdown = null}>
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.75684 13.2426L13.2421 4.75736" stroke="#173556" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M13.2421 13.2426L4.75684 4.75735" stroke="#173556" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>        
        </span>
      </div>

      {#if countries.length > 0}
        <div class="flex flex-col overflow-y-scroll" style="max-height: 60vh;">
            <ul>
                {#each countries as country}
                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    <li class="flex justify-between items-center my-3 py-2 hover:bg-gray-100 hover:shadow-sm" on:click={() => handleSelectCountry(country)}>
                        <div>
                            <div class="flex text-gray-900">
                                <img src={ICONS[country.code?.toLowerCase()]} alt="{country.code}-logo" width="20px" style="height: 20px"  />
                                &nbsp;
                                { country.name }
                            </div>
                        </div>
                        <div>
                            { country.tel }
                        </div>
                    </li>
                {/each}
            </ul>
        </div>
      {:else}
        <div class="mb-4 text-xs text-center mt-4">
            No country available
        </div>
      {/if}
    </div>
  {/if}
</div>
{/if}

<AuthHeader />
<div class="flex h-full justify-center items-center">
    <div class="w-full">
        <div class="flex flex-col">
            <div class="contact">
                <div class="flex flex-col justify-center items-center mt-10 mb-8 px-16 text-center text-gray-500">
                    <strong class="text-lg text-gray-800">
                        Seamlessly call your customers
                    </strong>
                    <span class="text-gray-500 text-xs font-thin">
                        Type a number below and dial
                    </span>
                </div>
                <div class="relative mx-8 my-1 mb-6">
                    <div class="border-b border-black w-full mr-2 flex">
                        <!-- svelte-ignore a11y-click-events-have-key-events -->
                        <span class="flex items-center" on:click={() => dropdown = 1}>
                            <span class="rounded-full overflow-hidden w-5 h-5 items-center cursor-pointer">
                                <img src={ICONS[country.code?.toLowerCase()]} alt="{country.code}-logo" width="20px" style="height: 20px"  />
                            </span> &nbsp;
                            <Icon size="12" color="#aaa" icon="toggle"/>
                        </span>
                        <span class="text-sm ml-2 flex items-center">{ country.tel }</span>
                        <input
                            placeholder="080 0000 0000"
                            bind:value={phone}
                            use:focus
                            class="border-0 { error ? 'border-red-500' : ''} mr-2 px-2 py-1 text-sm"
                        />
                    </div>
                </div>
            </div>
            <div class="w-full flex items-center justify-center">
                <ButtonRounded
                    disabled={!$callStore.sipConnected}
                    on:click={initCall}
                    size="16"
                    title=""
                    icon="start-call"
                    iconColor="#30A059"
                    iconSize=30
                    className="{$callStore.sipConnected ? indicateConnection ? 'bg-green-700' : 'call-btn-bg-color border-2 border-blue-500' : 'bg-gray-400'} w-16 h-16"
                />
            </div>
        </div>
    </div>
</div>
<AuthFooter />
<style lang="scss">
</style>